<template>
  <v-card :height="height" elevation="0" class="addWidget">
    <v-col class="addWidgetBox fill-height">
      <!-- <v-row>
      <v-col>-->
      <!-- <v-row > -->
      <v-row align="center" class="ma-auto pb-0 pt-4 fill-height">
        <v-col sm="12"  align="center" justify="center">
          <v-btn
            fab
            small
            :ripple="false"
            :depressed="true"
            :color="btnColor()"
            @click.stop="openAddEditWidgetDialog()"
          >
            <v-icon medium :color="iconColor()">add</v-icon>
          </v-btn>
          <div class="subheading font-weight-bold">Add Widget</div>
        </v-col>
      </v-row>
      <!-- </v-row> -->
    </v-col>
    <!-- </v-row>
    </v-col>-->
  </v-card>
</template>

<script>
import colors from '@/constants/colors';
import { mapMutations } from 'vuex';

export default {
  props: ['height', 'widgetInfo'],
  data() {
    return {
      addEditWidgetDialogIsOpen: false,
      darkTheme: null
    };
  },
  methods: {
    ...mapMutations('dashboard', ['toggleAddEditModal', 'setSelectedForEdit']),
    openAddEditWidgetDialog() {
      this.toUpdate = false;
      this.setSelectedForEdit(this.widgetInfo);
      this.toggleAddEditModal(true);
    },
    btnColor() {
      return this.darkTheme ? colors.white : colors.addWidgetBtn;
    },
    iconColor() {
      return this.darkTheme ? colors.addWidgetBtnOuter : colors.addWidgetBtnDark;
    }
  },
  mounted() {
  }
};
</script>
<style>
.container.addWidgetBox {
  padding: inherit;
}

.theme--light.v-sheet.addWidget,
.theme--dark.v-sheet.addWidget {
  --border-color: #b3b3b3;
  --border-weight: 2px;
  --dash-size: 16px;
  --gap-size: 14px;
  background-color: transparent;
}

.theme--light.v-sheet.addWidget:hover,
.theme--dark.v-sheet.addWidget:hover {
  /* --border-color: #fff;  */
  --border-weight: 3px;
  --dash-size: 10px;
  --gap-size: 8px;
}

.theme--light.v-sheet.addWidget:before,
.theme--dark.v-sheet.addWidget:before {
  transition: all 0.6s ease;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, var(--border-color) 100%, transparent 100%)
      top left no-repeat,
    linear-gradient(
        90deg,
        transparent calc(var(--gap-size) / 2),
        var(--border-color) calc(var(--gap-size) / 2),
        var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),
        transparent calc(var(--gap-size) / 2 + var(--dash-size))
      )
      top center repeat-x,
    linear-gradient(90deg, var(--border-color) 100%, transparent 100%) top right
      no-repeat,
    linear-gradient(0deg, var(--border-color) 100%, transparent 100%) top left
      no-repeat,
    linear-gradient(
        0deg,
        transparent calc(var(--gap-size) / 2),
        var(--border-color) calc(var(--gap-size) / 2),
        var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),
        transparent calc(var(--gap-size) / 2 + var(--dash-size))
      )
      center left repeat-y,
    linear-gradient(0deg, var(--border-color) 100%, transparent 100%) bottom
      left no-repeat,
    linear-gradient(90deg, var(--border-color) 100%, transparent 100%) bottom
      left no-repeat,
    linear-gradient(
        90deg,
        transparent calc(var(--gap-size) / 2),
        var(--border-color) calc(var(--gap-size) / 2),
        var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),
        transparent calc(var(--gap-size) / 2 + var(--dash-size))
      )
      bottom center repeat-x,
    linear-gradient(90deg, var(--border-color) 100%, transparent 100%) bottom
      right no-repeat,
    linear-gradient(0deg, var(--border-color) 100%, transparent 100%) top right
      no-repeat,
    linear-gradient(
        0deg,
        transparent calc(var(--gap-size) / 2),
        var(--border-color) calc(var(--gap-size) / 2),
        var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),
        transparent calc(var(--gap-size) / 2 + var(--dash-size))
      )
      center right repeat-y,
    linear-gradient(0deg, var(--border-color) 100%, transparent 100%) bottom
      right no-repeat;
  background-size: var(--dash-size) var(--border-weight),
    calc(var(--dash-size) + var(--gap-size)) var(--border-weight),
    var(--dash-size) var(--border-weight), var(--border-weight) var(--dash-size),
    var(--border-weight) calc(var(--dash-size) + var(--gap-size)),
    var(--border-weight) var(--dash-size);
}
</style>